import TextButton from "./TextButton"

const CTA = () => {
  return (
    <div className="cta">
        <h2>Ingin Mengajukan Pertanyaan Seputar ChiFlo</h2>
        <p>Tak perlu terus bersedih, kami siap membantu anda</p>
        <TextButton className="text-button" label="Ajukan Pertanyaan" />
    </div>
  )
}

export default CTA
